import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bed-size',
  templateUrl: './bed-size.component.html',
  styleUrls: ['./bed-size.component.css']
})
export class BedSizeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
